import { Directive, ElementRef, HostListener, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appFocus]',
})
export class FocusDirective implements OnInit, OnChanges {
  @Input('appFocus') public isFocused: boolean;
  constructor(private hostElement: ElementRef, private renderer: Renderer2) {}

  public ngOnInit(): void {
    if (this.isFocused) {
      this.renderer.selectRootElement(this.hostElement.nativeElement).focus();
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.isFocused && this.isFocused) {
      this.renderer.selectRootElement(this.hostElement.nativeElement).focus();
    }
  }

  @HostListener('keydown', ['$event'])
  public onkeydown(e: any) {
    e.preventDefault();
    const value = e.key;
    const reg = new RegExp('[0-9]');
    if (value.match(reg)) {
      e.target.value = value;
    }
    if (e.keyCode === 8) {
      e.target.value = '';
    }

    const { previousElementSibling, nextElementSibling, id } = this.hostElement.nativeElement;
    if ((parseInt(id, 10) === 0 && e.keyCode === 8) || (parseInt(id, 10) === 5 && e.keyCode !== 8)) {
      return;
    }
    if (e.keyCode === 8) {
      this.renderer.selectRootElement(previousElementSibling).focus();
    } else {
      this.renderer.selectRootElement(nextElementSibling).focus();
    }
  }
}
